export default () => {
    const contactForm = document.querySelector('form.hf-form');
    const formObject = document.querySelector('.js-form-object');
    
    if (contactForm && formObject) {
        let dataObject = document.querySelector('.js-form-object').dataset.formObject;
        
        contactForm.querySelector('input[name="OGGETTO"]').placeholder = dataObject;
        contactForm.querySelector('input[name="OGGETTO"]').value = dataObject;
    }
    
}